import { AppRoutingConstants } from "../../app-routing.constants";
import { StepRoutingConstants } from "../../step/step-routing.constants";
export class ViewApplicationRoutingConstants {
    static VIEW_APPLICATION_ROUTE = AppRoutingConstants.createRouteToView("view-application");
    static PARAMETERS_ROUTE = AppRoutingConstants.createRouteToView("parameters");
    static PROPERTY_ROUTE = AppRoutingConstants.createRouteToView("location");
    static STAKEHOLDERS_ROUTE = AppRoutingConstants.createRouteToView("traders");
    static DETAILS_ROUTE = AppRoutingConstants.createRouteToView("details");
    static PROFESSIONAL_BODIES_ROUTE = AppRoutingConstants.createRouteToView("professionalbodies");
    static PEOPLE_OF_INTEREST_ROUTE = AppRoutingConstants.createRouteToView("peopleofinterest");
    static DECEASED_ROUTE = AppRoutingConstants.createRouteToView("deceaseddetails");
    static FAMILY_ROUTE = AppRoutingConstants.createRouteToView("family");
    static GRAVE_ROUTE = AppRoutingConstants.createRouteToView("grave");
    static ATTACHMENTS_ROUTE = AppRoutingConstants.createRouteToView("attachments");
    static STEP_MANAGEMENT_ROUTE = AppRoutingConstants.createRouteToView("stepmanagement");
    static TIMEOUTS_ROUTE = AppRoutingConstants.createRouteToView("timeouts");
    static SCHEDULED_REMINDERS_ROUTE = AppRoutingConstants.createRouteToView("scheduledreminders");
    static COMMUNICATION_ROUTE = AppRoutingConstants.createRouteToView("communication");
    static CONDITIONS_ROUTE = AppRoutingConstants.createRouteToView("conditions");
    static NOTES_ROUTE = AppRoutingConstants.createRouteToView("notes");
    static ASSESSMENT_ROUTE = AppRoutingConstants.createRouteToView("assessment");
    static SURVEY123_ROUTE = AppRoutingConstants.createRouteToView("survey123");
    static COMMENTS_ROUTE = AppRoutingConstants.createRouteToView("comments");
    static REQUEST_COMMENT_ROUTE = AppRoutingConstants.createRouteToView("requestcomment");
    static RESULT_ROUTE = AppRoutingConstants.createRouteToView("result");
    static TEAM_ROUTE = AppRoutingConstants.createRouteToView("team");
    static CHECKLIST_ROUTE = AppRoutingConstants.createRouteToView("checklist");
    static RELATED_APPLICATION = AppRoutingConstants.createRouteToView("relatedapplications");
    static REQUIRED_DOCUMENTS_CHECKLIST_ROUTE = AppRoutingConstants.createRouteToView("requireddocumentschecklist");
    static HISTORY_ROUTE = AppRoutingConstants.createRouteToView("history");
    static APPLICANT_ROUTE = AppRoutingConstants.createRouteToView("applicantapplicantagent");
    static VALUER = AppRoutingConstants.createRouteToView("valuermunicipalvaluer");
    static ADHOC_COMMS = AppRoutingConstants.createRouteToView("adhoccomms");
    static INVOICES_ROUTE = AppRoutingConstants.createRouteToView("invoices");
    static STATUS_ROUTE = AppRoutingConstants.createRouteToView("status");
    static APPLICATION_CONTENT_ROUTE = AppRoutingConstants.createRouteToView("content");
    static BLOCK_PROPERTIES = AppRoutingConstants.createRouteToView("blockproperties");
    static VIEW_OBJECTIONS = AppRoutingConstants.createRouteToView("objections");
    static VALUATION_BLOCK_FACTOR_ADJUSTMENT = AppRoutingConstants.createRouteToView("factoradjustment");
    static VALUATION_BLOCK_STRUCTURE_TYPE = AppRoutingConstants.createRouteToView("structuretype");
    static VALUATION_BLOCK_VALUE_ADJUSTMENT = AppRoutingConstants.createRouteToView("valueadjustment");
    static VALUATION_BLOCK_DEPRECIATION_FACTOR = AppRoutingConstants.createRouteToView("depreciationfactor");
    static VIEW_APPEALS = AppRoutingConstants.createRouteToView("appeals");
    static STEP_ROUTE = AppRoutingConstants.createRouteToView("step");
    static VALUATION_BLOCK_AGRICULTURE_ACTIVITY = AppRoutingConstants.createRouteToView("agricultureActivity");
    static VIEW_BLOCK_AVERAGES = AppRoutingConstants.createRouteToView("blockaverages");
    static PREMISES = AppRoutingConstants.createRouteToView("premises");
    static INSPECTIONS = AppRoutingConstants.createRouteToView("inspections");
    static APPLICANT_EHMS = AppRoutingConstants.createRouteToView("applicant");
    static STAMP_PDF = AppRoutingConstants.createRouteToView("stamppdf");
    static BUILDING_PLAN_APPLICATIONS = AppRoutingConstants.createRouteToView("buildingplanapplications");
    static JOB_ID_ROUTE_PARAMETER = ":jobID";
    static ATTRIBUTES_ROUTE = "attributes";
    static SPATIAL_FACTORS_ROUTE = "spatialfactors";
    static FACTORS_ROUTE = "factors";
    static VALUATION_ROUTE = "valuations";
    static PROP_INFO_ROUTE = "propdetails";
    static getStepRefreshRoute() {
        return `${ViewApplicationRoutingConstants.STEP_ROUTE}${AppRoutingConstants.ROUTE_SEPERATOR}${StepRoutingConstants.REFRESH}`;
    }
}
